import React from 'react';
import { ProjectMilestone } from '../../operations/services/PlantafelService';
import styles from './ProjectDetailPage.module.css';

interface GenerateJobsDialogProps {
  milestone: ProjectMilestone;
  generating: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function GenerateJobsDialog({
  milestone,
  generating,
  onConfirm,
  onCancel,
}: GenerateJobsDialogProps): React.JSX.Element {
  return (
    <div
      data-testid="generate-jobs-confirm-dialog"
      className={styles.modalOverlay}
      onClick={() => { if (!generating) onCancel(); }}
    >
      <div
        className={`${styles.modalBox} ${styles.modalBoxSm}`}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className={styles.modalTitle}>Jobs erzeugen?</h3>
        <p className={styles.modalText}>
          Erstellt Jobs im Backlog aus den diesem Milestone zugeordneten Leistungen.
          Bereits vorhandene Jobs werden übersprungen.
        </p>
        <div className={styles.modalInfoBox}>
          <strong>Milestone:</strong> {milestone.label}
          <br />
          <strong>Leistungen:</strong> {milestone.positions?.length || 0}
        </div>
        <div className={styles.modalActions}>
          <button
            onClick={onCancel}
            disabled={generating}
            className={styles.cancelButton}
            style={{ cursor: generating ? 'not-allowed' : 'pointer' }}
          >
            Abbrechen
          </button>
          <button
            data-testid="generate-jobs-confirm-btn"
            onClick={onConfirm}
            disabled={generating}
            className={styles.confirmButton}
            style={{
              background: generating ? '#9ca3af' : '#021a4a',
              cursor: generating ? 'not-allowed' : 'pointer',
            }}
          >
            {generating ? 'Erzeuge Jobs...' : 'Jobs erzeugen'}
          </button>
        </div>
      </div>
    </div>
  );
}

interface InvoiceConfirmDialogProps {
  milestone: ProjectMilestone;
  creating: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function InvoiceConfirmDialog({
  milestone,
  creating,
  onConfirm,
  onCancel,
}: InvoiceConfirmDialogProps): React.JSX.Element {
  const posCount = milestone.positions?.length || 0;
  const eurFmt = (v: number) =>
    new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(v);

  return (
    <div
      data-testid="create-invoice-confirm-dialog"
      className={styles.modalOverlay}
      onClick={() => { if (!creating) onCancel(); }}
    >
      <div
        className={`${styles.modalBox} ${styles.modalBoxMd}`}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className={styles.modalTitle}>
          Rechnung für Milestone &apos;{milestone.label}&apos; erstellen?
        </h3>
        <p className={styles.modalText}>
          Enthält: {posCount} Leistung{posCount !== 1 ? 'en' : ''} • Summe netto:{' '}
          {eurFmt(milestone.positions_total_net || 0)}
        </p>
        <div className={styles.modalInfoBox}>
          <strong>Status:</strong> Bereit zur Rechnung
          <br />
          <strong>Milestone-Betrag:</strong> {eurFmt(milestone.amount || 0)} (
          {milestone.percent}%)
        </div>
        <div className={styles.modalActions}>
          <button
            onClick={onCancel}
            disabled={creating}
            className={styles.cancelButton}
            style={{ cursor: creating ? 'not-allowed' : 'pointer' }}
          >
            Abbrechen
          </button>
          <button
            data-testid="create-invoice-confirm-btn"
            onClick={onConfirm}
            disabled={creating}
            className={styles.confirmButton}
            style={{
              background: creating ? '#9ca3af' : '#021a4a',
              cursor: creating ? 'not-allowed' : 'pointer',
            }}
          >
            {creating ? 'Erstelle Rechnung...' : 'Rechnung erstellen'}
          </button>
        </div>
      </div>
    </div>
  );
}
